import React from "react";
import PropTypes from "prop-types";

const Row = (props) => {
  return (
    <div className={props.config.class} id={props.config.id}>
      {props.children}
    </div>
  );
};

Row.propTypes = {
  config: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
};

export default Row;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Group/Row.js